export interface MoversTopicConfig {
    includePositive: boolean;
    includeNegative: boolean;
}

export const defaultMoversTopicConfig: MoversTopicConfig = {
    includeNegative: true,
    includePositive: true,
};
